<template>
    <div id="app" style="">
        <router-view />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {
        this.handleResize(); // 在组件挂载时获取浏览器宽度
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            const baseSize = 1903; // 设计稿宽度
            const scale = window.innerWidth / baseSize;
            document.documentElement.style.fontSize = `${scale * 100}px`; // 假设你希望 1rem = 10 * scale px
        },
    },
};
</script>

<style lang="scss">
html {
    font-size: 100px;
    // font-size: calc(100vw * 100 / 1294);
    height: 100vh;
    body {
        height: 100vh;
        font-size: 0.14rem;
        margin: 0;
        padding: 0;
        // #app {
        //     font-family: Avenir, Helvetica, Arial, sans-serif;
        //     -webkit-font-smoothing: antialiased;
        //     -moz-osx-font-smoothing: grayscale;
        //     text-align: center;
        //     color: #2c3e50;
        //     margin-top: 60px;
        // }
    }
}
</style>
